module.exports = __webpack_public_path__ + "static/media/logo-footer.7015359f.png";